import {IcnArrowLeft, IcnClose} from "../../assets/icons";

import React, {ReactNode} from "react";

import {useIsMobile} from "../../providers/IsMobileProvider";

import Button from "./Button";

interface ModalFormWrapperProps {
  onCloseModal: () => void;
  headerTitle?: string;
  hideBackButton?: boolean;
  onClick?: () => void;
  children?: ReactNode;
}

function ModalFormWrapper(
  {
    onCloseModal,
    headerTitle,
    hideBackButton,
    onClick,
    children,
  }:ModalFormWrapperProps) {
  const {isMobile} = useIsMobile();

  return (
    <>
      <div className="c-modal-header">

        {!hideBackButton && (
          <div className="c-modal-header-back-btn-wrapper">
            <Button
              btnColor="grey"
              title="Back"
              btnSize={isMobile? undefined : "lg"}
              icon={<IcnArrowLeft/>}
              onClick={onClick}
            />
          </div>
        )}

        <h1 className="h4">{headerTitle}</h1>

        <div className="c-modal-header-close-btn-wrapper">
          <Button
            extraClassName="c-modal-header-close-btn"
            btnVariant="icon"
            btnSize={isMobile? undefined : "lg"}
            btnColor="grey"
            title="Close"
            icon={<IcnClose/>}
            onClick={onCloseModal}
          />
        </div>

      </div>

      <div className="c-modal-form-wrapper">
        {children}
      </div>

    </>
  );
}

export default ModalFormWrapper;